// Copy for the shared contact form (ContactForm + its parts in components/contact/ + useContactForm).
const en = {
  heading: 'Contact our team',
  fullName: "What's your full name? *",
  fullNamePlaceholder: 'Jane Smith',
  workEmail: "What's your work email? *",
  workEmailPlaceholder: 'jane@company.com',
  company: 'What company do you work for?',
  companyPlaceholder: 'Big Tech company',
  companySize: 'How many employees does your company have?',
  companySizePlaceholder: '1-15',
  companySizeOptions: ['1-15', '16-50', '50-200', 'more than 200'],
  optional: '(optional)',
  howCanWeHelp: 'How can we help?',
  verifyHuman: "Verify you're human: 7 + 1",
  privacyNotice: 'By sending this form, you acknowledge that Stratodata will process your personal data to respond to your enquiry. More in our ',
  privacyPolicyLink: 'Privacy Policy',
  privacyNoticeEnd: '.',
  submit: 'Send message',
  sending: 'Sending...',
  successTitle: 'Thank you!',
  successText: "We've received your message and will be in touch shortly.",
  sendAnother: 'Send another message',
  // Validation + toasts
  nameError: 'Name must be at least 2 characters',
  emailError: 'Please enter a valid email address',
  humanCheckError: 'Please enter the correct result.',
  toastSuccess: 'Thank you!',
  toastError: 'There was an error submitting your message. Please try again.',
  toastErrorDetail: ' Error: ',
};

const sk: typeof en = {
  heading: 'Kontaktujte náš tím',
  fullName: 'Vaše meno a priezvisko *',
  fullNamePlaceholder: 'Jana Nováková',
  workEmail: 'Váš pracovný e-mail *',
  workEmailPlaceholder: 'jana@firma.sk',
  company: 'V akej firme pracujete?',
  companyPlaceholder: 'Názov firmy',
  companySize: 'Koľko zamestnancov má vaša firma?',
  companySizePlaceholder: '1-15',
  companySizeOptions: ['1-15', '16-50', '50-200', 'viac ako 200'],
  optional: '(nepovinné)',
  howCanWeHelp: 'S čím vám môžeme pomôcť?',
  verifyHuman: 'Overte, že nie ste robot: 7 + 1',
  privacyNotice: 'Odoslaním formulára beriete na vedomie, že Stratodata spracuje vaše osobné údaje, aby mohla odpovedať na váš dopyt. Viac nájdete v našich ',
  privacyPolicyLink: 'Zásadách ochrany osobných údajov',
  privacyNoticeEnd: '.',
  submit: 'Odoslať správu',
  sending: 'Odosiela sa...',
  successTitle: 'Ďakujeme!',
  successText: 'Vašu správu sme dostali a čoskoro sa vám ozveme.',
  sendAnother: 'Poslať ďalšiu správu',
  nameError: 'Meno musí mať aspoň 2 znaky',
  emailError: 'Zadajte platnú e-mailovú adresu',
  humanCheckError: 'Zadajte správny výsledok.',
  toastSuccess: 'Ďakujeme!',
  toastError: 'Pri odosielaní správy nastala chyba. Skúste to, prosím, znova.',
  toastErrorDetail: ' Chyba: ',
};

export const contactFormCopy = { en, sk };
